module.exports = __webpack_public_path__ + "img/img.daa7e714.jpg";